export default {"src":"/_next/static/media/sad-glopi.6b7dd1e7.svg","height":371,"width":228,"blurWidth":0,"blurHeight":0};